export class Environment {
    public production: boolean;
    public backendUrl: string;
    public msApplicationId: string;
    public desktop: boolean;
}
